import { z } from 'zod';
import { CanonicalId, Id, Digest, parse } from './contracts.mjs';
import { requireCondition } from './errors.mjs';

export const PublicNativeMapping = z.strictObject({
  schemaVersion: z.literal(1),
  artifactId: CanonicalId,
  revisionId: CanonicalId,
  buildId: Id,
  manifestDigest: Digest,
  targets: z
    .array(z.strictObject({ canonicalNodeId: CanonicalId, pid: Id, targetId: Id }))
    .max(50000),
});

// Derived only from the current accepted private manifest. Lookup is geometry
// metadata, never source/edit authority or a client-submitted mapping store.
export function createNativeInspectMap(raw, expected) {
  const mapping = parse(PublicNativeMapping, raw);
  for (const field of ['artifactId', 'revisionId', 'buildId', 'manifestDigest'])
    requireCondition(mapping[field] === expected[field], 'manifest_binding_mismatch');
  const byCanonical = new Map();
  const byPid = new Map();
  const targets = new Set();
  for (const entry of mapping.targets) {
    requireCondition(!byCanonical.has(entry.canonicalNodeId), 'duplicate_native_identity');
    requireCondition(
      !byPid.has(entry.pid) && !targets.has(entry.targetId),
      'duplicate_manifest_target',
    );
    targets.add(entry.targetId);
    byCanonical.set(entry.canonicalNodeId, entry.pid);
    byPid.set(entry.pid, entry.canonicalNodeId);
  }
  return Object.freeze({
    pidFor: (canonicalNodeId) => byCanonical.get(canonicalNodeId) ?? null,
    canonicalFor: (pid) => byPid.get(pid) ?? null,
  });
}
